import React from 'react'

const MouseIcon = () => {
    return (
        <div className="flex justify-center items-center mt-10">
            <div className="border-2 border-white rounded-full w-8 h-14 relative">
                <div className="w-2 h-2.5 bg-white rounded-full absolute top-3 left-[37%] transform-translate-x-[1/2] animate-bounce"></div>
            </div>
        </div>
    )
}

export default MouseIcon


